<template>
  <div class="payback">
    <div class="h2">分期信息</div>
    <div class="cktbox">  
      <div class="chbox">
        <a href="javascript:void(0);" v-for='(i,index) in loan' :key='i.id' :class="{'cur':loanIndex==index}" @click='loanIndex=index'>分期{{index+1}}</a>
      </div>
    </div>
    <div class="colsown">
      <div class="tl">
        <div class="sapn" v-for='i in rPropo(nowLoan.fee)'>{{i.type_title}}：{{i.fee/100}}元</div>
      </div>
      <div class="btl">
        <div class="sapn">总合计金额： <span>{{nowLoan.total/100}}元</span></div>
        <div class="sapn">分期期数： <span>共{{nowLoan.quantity}}期</span></div>
      </div>
      <div class="isover" v-if="nowLoan.status==4"></div>
      <div class="csays">
        <label>备注：</label>
        <div class="says" v-html='nowLoan.comment'></div>
      </div>
      <div class="h3">分期详情</div>
      <div class="table">
        <table>
          <thead>
            <td width='232'>每期编号</td>
            <td width='142'>当前期数</td>
            <td width='126'>履行金额</td>
            <td width='150'>履行日期</td>
            <td width='120'>履行构成</td>
            <td width='122'>履行状态</td>
            <td width='118'>已还金额</td>
            <td width='138'>履行进度</td>
          </thead>
          <tbody>
            <tr v-for='(i,index) in nowLoan.period' :key='index'>
              <td>
                <Normap :tit='i.no'></Normap>
              </td>
              <td>第{{index+1}}期</td>
              <td>{{i.fee/100 | toNum}}</td>
              <td>{{i.time}}</td>
              <td>
                <a-popover>
                  <template slot="content">
                      <div class="contbox">
                          <p v-for='(k,inde) in i.fee_list'>{{k.type_title}}:{{k.fee | showYuan}}</p>
                      </div>
                  </template>
                  <span> {{Allfree(i.fee_list)}}</span>
                </a-popover>
              </td>
              <td>
                <span class="status ing" v-if='i.status==1'>待履行</span>
                <span class="status succ" v-if='i.status==2'>已履行</span>
                <span class="status err" v-if='i.status==3'>已逾期</span>
                <span class="status oky" v-if='i.status==4'>已执行</span>
              </td>
                  <td>
                    {{i.payee/100 | toNum}}
                  </td>
                  <td>
                    {{(i.payee/i.fee*100).toFixed(2)}}%
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
    </div>
</template>
<script>
import Proposition from '@/page/payback/step.json'
export default {
  props:{
    loan:Array
  },
  data(){
    return {
      loanIndex:0,
    }
  },
  computed:{
    nowLoan(){
      return this.loan[this.loanIndex]
    }
  },
  mounted(){
    this.loanIndex=this.loan.length-1
  },
  methods:{
    Allfree(Arr) {
      let i = 0;
      Arr.map(e => {
        i += e.fee * 1 / 100
      })
      return i.toFixed(2)
    },
    rPropo(Arr) {
      let newArr = []
      Proposition.map(ele => {
        let s = Arr.find(s => { return s.type == ele.type })
        if (ele.type != 6) {
          newArr.push({
            type_title: ele.tit,
            type: ele.type,
            fee: s ? s.fee : 0
          })
        }
      })
      return newArr
    },
  }
}
</script>
<style lang="less" scoped>
.isover{
  position: absolute;
  left:0;
  top: 0;
  width: 180px;
  height: 180px;
  background: url('../../assets/img/err.png') no-repeat;
  background-size: 100% 100%;
}
.cktbox {
    display: flex;
    justify-content: space-between;
    height: 55px;
    margin: 0 20px;
    border-bottom: 1px solid #efefef;
    align-items: center;
    .chbox {
      display: flex;
      a {
        font-size: 0.875rem;
        color: #0e2949;
        margin-right: 40px;
      }
      .cur,
      a:hover {
        color: #1d8bfe;
      }
    }
  }
  .h2 {
    line-height: 60px;
    font-size: 1rem;
    font-weight: bold;
    color: #0e2949;
    padding: 0 20px;
    border-bottom: 1px solid #efefef;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .rows {
    margin: 20px 20px 0 20px;
    font-size: 0.875rem;
    color: #0e2949;
    line-height: 20px;
    span {
      color: #66707c;
    }
  }
  .colsown {
    padding: 40px 20px 20px;
    position: relative;
    .tl {
      display: flex;
      font-size: 0.875rem;
      width: 1020px;
      flex-wrap: wrap;
      color: #0e2949;
      line-height: 20px;

      .sapn {
        width: 204px;
        margin-bottom: 10px;
      }
    }
    .btl {
      padding-top: 1.25rem;
      display: flex;
      font-size: 0.875rem;
      color: #0e2949;
      line-height: 20px;
      margin-bottom: 10px;
      .sapn {
        width: 204px;
        span {
          color: #0e2949;
          font-weight: bold;
        }
      }
    }
    .h3 {
    line-height: 60px;
    font-size: 0.875rem;
    color: #0e2949;
    font-weight: bold;
  }
  .bots {
    margin-top: 10px;
    padding: 0 20px 20px;
    background: #fff;
    margin-bottom: 10px;
  }
    .csays {
      display: flex;
      .says {
        width: 552px;
        font-size: 0.875rem;
        color: #66707c;
        line-height: 20px;
      }
    }
  }
</style>